/**
 * Fix de compatibilidad — Sticky Add to Cart nativo de Savor
 * Archivo: assets/sticky-add-to-cart-fix.js
 *
 * PROBLEMA:
 * El tema envuelve todo el contenido en un <div class="page-wrapper"> que
 * tiene su propio scroll interno (overflow-y: auto), en vez de dejar que
 * la página (window/body) haga el scroll normalmente. La barra nativa de
 * Shopify (<sticky-add-to-cart>) decide cuándo mostrarse basándose en el
 * scroll real de la página, así que con esta estructura nunca se activa:
 * se queda siempre con data-stuck="false" y opacity: 0, invisible.
 *
 * SOLUCIÓN:
 * Este script escucha el scroll del contenedor real (.page-wrapper) y
 * controla manualmente la visibilidad de la barra, reutilizando el HTML/CSS
 * que Shopify ya genera (imagen, título, precio, botón) — solo se re-conecta
 * la lógica de "cuándo mostrarla".
 */
(function () {
  'use strict';

  function init() {
    const wrapper = document.querySelector('.page-wrapper');
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!wrapper || !bar) return;

    // Botón de referencia: el submit estándar de Shopify en productos
    // normales, o el botón del personalizador en productos que usan ese
    // flujo (ej. Carta Hogwarts Personalizable).
    const trigger =
      document.querySelector('.product-form__submit button[type="submit"]') ||
      document.querySelector('product-form button[name="add"]') ||
      document.querySelector('[name="add"]') ||
      document.querySelector('.personalizador__boton-abrir');

    if (!trigger) return;

    // El modal del personalizador (si existe en esta página) no debe
    // dejar la barra sticky visible por encima de él.
    const modalPersonalizador = document.getElementById('PersonalizadorModal');

    // Widget de chat (Shopify Inbox / shopify-chat). Tiene un z-index
    // casi máximo, así que en vez de pelear por capas, lo desplazamos
    // hacia arriba mientras la barra sticky esté visible.
    const chatWidget = document.querySelector('shopify-chat');

    let estadoActual = null;

    function actualizar() {
      const rect = trigger.getBoundingClientRect();
      const modalAbierto = modalPersonalizador && !modalPersonalizador.hasAttribute('hidden');
      const fueraDeVista = rect.bottom < 0;
      const debeMostrarse = fueraDeVista && !modalAbierto;

      if (debeMostrarse === estadoActual) return;
      estadoActual = debeMostrarse;

      bar.dataset.stuck = debeMostrarse ? 'true' : 'false';
      bar.style.opacity = debeMostrarse ? '1' : '0';
      bar.style.pointerEvents = debeMostrarse ? 'auto' : 'none';

      if (chatWidget) {
        chatWidget.style.transition = 'transform 0.2s ease';
        chatWidget.style.transform = debeMostrarse
          ? `translateY(-${bar.offsetHeight + 12}px)`
          : '';
      }
    }

    // El scroll real puede pasar en .page-wrapper (desktop, donde el
    // tema le da su propio overflow) o en window/document (móvil, donde
    // .page-wrapper no scrollea y la página se comporta normal). Se
    // escuchan ambos: el que no aplique en cada caso simplemente no dispara.
    wrapper.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar);

    // Si el modal del personalizador abre/cierra, recalcular también
    if (modalPersonalizador) {
      new MutationObserver(actualizar).observe(modalPersonalizador, {
        attributes: true,
        attributeFilter: ['hidden'],
      });
    }

    actualizar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();